import { Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { useEffect, useState } from 'react';

import { Column } from 'common/components/Table/CommonTableStyles';
import TableComponent from 'common/components/Table/Table';
import { truncateString } from 'common/utils/utilFunctions';

import { IRegulationIncomingData } from '../../../RegulationChange/api/type-def';

import styles from './IncomingTable.module.scss';

export const formatedDate = (time: string) => {
	if (time) {
		const date = new Date(time);
		const formattedDate = date.toLocaleString('en-US', {
			month: '2-digit',
			day: '2-digit',
			year: '2-digit',
		});
		return formattedDate;
	}
	return '';
};

interface ISearchProps {
	data?: IRegulationIncomingData[];
	isLoading: boolean;
	totalRecordsCount: number;
	handlePageChange: (data: any, flag?: boolean) => void;
	handleSortChange: (data: any) => void;
	defaultQuery?: any;
}

const IncomingTable = (props: ISearchProps) => {
	const {
		data,
		isLoading,
		totalRecordsCount,
		handlePageChange,
		handleSortChange,
		defaultQuery,
	} = props;
	const [incomingTableData, setIncomingTableData] = useState<
		IRegulationIncomingData[]
	>([]);

	useEffect(() => {
		if (data) {
			setIncomingTableData(data);
		}
	}, [data]);

	const columns: readonly Column[] = [
		{
			id: 'citationParagraphId',
			label: 'Citation name',
			isSortable: true,
			disablePadding: false,
			render: (params: IRegulationIncomingData) => (
				<Typography
					// onClick={() => navigationToCitationDetail(params.id, params.citationParagraphId)}
					className={styles['navigate-data-field']}
					data-testid="citation-link"
				>
					<Tooltip title={params?.citationParagraphId} placement="bottom-start">
						<span>
							{params?.citationParagraphId.length > 35
								? `${truncateString(params?.citationParagraphId, 35)}...`
								: params?.citationParagraphId}
						</span>
					</Tooltip>
				</Typography>
			),
		},
		{
			id: 'regulationId',
			label: 'Regulation',
			disablePadding: false,
			isSortable: true,
		},
		{
			id: 'issuanceDate',
			label: 'Review deadline',
			disablePadding: false,
			render: (params: IRegulationIncomingData) => (
				<Typography className={styles['text-styling']}>
					{formatedDate(params.issuanceDate)}
				</Typography>
			),
		},
		{ id: 'issuanceType', label: 'Issuance type', disablePadding: false },
		{ id: 'agency', label: 'Regulator', disablePadding: false },
		{
			id: 'linkUrl',
			label: 'PDF link',
			disablePadding: false,
			render: (params: IRegulationIncomingData) => (
				<div className={styles['link-styling']}>
					<a href={params.linkUrl} target="_blank" rel="noreferrer">
						{params.linkUrl}
					</a>
				</div>
			),
		},
	];

	return (
		<Box
			className={styles['risks-table-box']}
			data-testid="regulation-list-table"
		>
			<TableComponent
				defaultQuery={defaultQuery}
				rows={incomingTableData}
				columns={columns}
				totalItems={totalRecordsCount}
				defaultSortKey=""
				onPageHandler={handlePageChange}
				isLoading={isLoading}
				tableStyles={{ minWidth: '46.875em', maxHeight: '27.5em' }}
				onSortHandler={handleSortChange}
				enableHeaderColor
				isRenderPagination
			/>
		</Box>
	);
};

export default IncomingTable;
